import { AxiosError } from 'axios'

export function handleNetworkErrorException(e: AxiosError): void {
  console.log('Network error', e)
}

export function handleUnauthorizedException(e: AxiosError): void {
  console.log('Unauthorized exception', e)
  localStorage.removeItem('access_token')
  localStorage.removeItem('user')
  localStorage.removeItem('system_uid')
  window.location.href = '/login'
}

export function handleForbiddenException(e: AxiosError): void {
  console.log('Forbidden exception', e)
}
